import type {
  ApiResponse,
  OptimizationHistoryItem,
  Paginated,
  Pagination,
} from '../types/api';

export function parseOptimizationHistoryResponse(
  response: ApiResponse<unknown> & { pagination?: Pagination }
): { items: OptimizationHistoryItem[]; pagination: Pagination | null } {
  const root = response as ApiResponse<unknown> & { pagination?: Pagination };
  const data = root.data;

  const nestedPagination =
    data && typeof data === 'object' && !Array.isArray(data)
      ? (data as Paginated<OptimizationHistoryItem>).pagination
      : undefined;

  const pagination = root.pagination ?? nestedPagination ?? null;

  let items: OptimizationHistoryItem[] = [];
  if (Array.isArray(data)) {
    items = data;
  } else if (data && typeof data === 'object') {
    const paginated = data as Paginated<OptimizationHistoryItem>;
    items = Array.isArray(paginated.items) ? paginated.items : [];
  }

  if (!pagination && items.length > 0) {
    return {
      items,
      pagination: { limit: items.length, offset: 0, total: items.length },
    };
  }

  return { items, pagination };
}

export function splitOptimizationHistoryByCategory(items: OptimizationHistoryItem[]): {
  multiAgent: OptimizationHistoryItem[];
  integrations: OptimizationHistoryItem[];
} {
  const multiAgent: OptimizationHistoryItem[] = [];
  const integrations: OptimizationHistoryItem[] = [];

  for (const item of items) {
    if (item.integration_id) {
      integrations.push(item);
    } else {
      multiAgent.push(item);
    }
  }

  const sortByDate = (a: OptimizationHistoryItem, b: OptimizationHistoryItem) =>
    new Date(b.created_at).getTime() - new Date(a.created_at).getTime();

  return {
    multiAgent: multiAgent.sort(sortByDate),
    integrations: integrations.sort(sortByDate),
  };
}
